import { create } from "zustand";

const totalNlcStore = create((set, get) => ({
  totalNlc: 0,
  setTotalNlc: (newValue) => {
    if (newValue === get().totalNlc) {
      return;
    }
    set(() => ({
      totalNlc: newValue
    }));
  }
}));

export default totalNlcStore;
